import { WorkflowEditorService } from 'api-clients/monolith';
import { useApiService } from 'hooks';
import React from 'react';

export function useAvailableRuleStages({ funnelSlug }: { funnelSlug: string }) {
  const fetchAvailableRuleStageTypes = React.useCallback(
    () =>
      WorkflowEditorService.getInternalApiWorkflowEditorFunnelsRuleStageTypes(
        funnelSlug,
      ),
    [funnelSlug],
  );

  return useApiService(fetchAvailableRuleStageTypes);
}
